import React from 'react'

export type StepProps = {
  title: string
  /** Fires when advancing forward off this step — the footer Next/Complete
   *  button or a header step click. Return `false` (or a promise resolving
   *  to `false`) to keep the user on this step — handy for "validate first,
   *  then advance" flows. */
  onNext?: () => boolean | void | Promise<boolean | void>
  onPrevious?: () => void
  errors?: string[]
  disabled?: boolean
  loading?: boolean
  formSubmit?: boolean
  completed?: boolean // handled within Stepper
  className?: string
  children?: React.ReactNode
  hideNext?: boolean
  /** Opt-in: pair with `<Stepper form={...}>` to have the Stepper
   *  auto-gate Next on validation errors for these rhf field paths.
   *  The cleaner pattern is to compute `disabled` yourself and skip
   *  this prop entirely — but it's left in for terse one-offs where
   *  you'd rather not wire `useFormState` at the call site. */
  fields?: string[]
  /** Content rendered in the footer to the left of the Next button */
  footerContent?: React.ReactNode
}

/** Only meaningful as a child of `<Stepper />`, which reads its props. */
export const Step = ({ className, children }: StepProps) =>
  !className ? <>{children}</> : <div className={className}>{children}</div>
